import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const updateUser = (userId, data) => {
  return new Promise((resolve, reject) => {
    const URL = `${routes.UPDATE_USER}/${userId}`;
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    axios
      .put(URL, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default updateUser;
